import { CloudArrowUpIcon, LockClosedIcon, ServerIcon } from '@heroicons/react/20/solid'
import ImarikaInvPlanTabs from './ImarikaInvPlanTabs'
import Imarika from "../../assets/Imarika.jpg"

const features = [
  {
    name: 'How does Investment Linked Product?',
    description:
      'Imarika offers superior returns, flexibility, affordability and insurance protection. You can make regular contributions from as low as Kes 1,000 daily, weekly or monthly. You can also opt for lumpsum contributions from Kes 50,000. There is no upper limit to how much or how often you can contribute. As you contribute, your funds earn competitive returns. At the end of the selected period, the policy pays the maturity value to the policyholder.',
    icon: CloudArrowUpIcon,
  },
  {
    name: 'Who should buy Investment Linked Product?',
    description: 'Suitable for people looking to accumulate money within the medium to long term. It is targeted at clients who are looking for superior returns for their investments to achieve their goals. Clients with other investment products looking to diversify should also consider Imarika.',
    icon: LockClosedIcon,
  },

]

export default function ImarikaInvPlan() {
  return (
    <div>
    <div className="overflow-hidden bg-white py-24 border-t border-gray sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:pr-8 lg:pt-4">
            <div className="lg:max-w-lg">
              <h2 className="text-base font-semibold leading-7 text-indigo-600">Unit Linked Products</h2>
              <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Imarika Investment Plan</p>
              <p className="mt-6 text-lg leading-8 text-gray-600">
              Imarika is a medium term goal driven, Unit-linked solution that offers you the opportunity to earn superior returns and enjoy life insurance at the same time. The plan enables you to plan and achieve your goals, whether it is saving for a child’s education, creating a fund to start or expand your business, buy or build your new home or simply to diversify your investment options.
              </p>
              <dl className="mt-10 max-w-xl space-y-8 text-base leading-7 text-gray-600 lg:max-w-none">
                {features.map((feature) => (
                  <div key={feature.name} className="relative ">
                    <dt className="inline font-semibold text-gray-900">
                      {feature.name}
                    </dt>{' '}
                    <dd className="inline">{feature.description}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
          <img
            src={Imarika}
            alt="Product screenshot"
            className="w-[48rem] max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem] md:-ml-4 lg:-ml-0"
            width={2432}
            height={1442}
          />
        </div>
      </div>
    </div>
    <div className='px-24'><ImarikaInvPlanTabs/></div>
    
    </div>
  )
}
